"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildExpenseKindTriggerConditionForAllRequestTypes = void 0;
const expenseKind_enum_1 = require("../models/expense/expenseKind.enum");
const workflowCondition_enum_1 = require("../models/workflow/workflowCondition.enum");
const buildExpenseKindTriggerConditionForAllRequestTypes = (isTravelEnabled) => {
    const commonExpenseKinds = [
        expenseKind_enum_1.RequestKindEnum.ONE_TIME_EXPENSE,
        expenseKind_enum_1.RequestKindEnum.SUBSCRIPTION,
        expenseKind_enum_1.RequestKindEnum.RECURRING_SUBSCRIPTION,
        expenseKind_enum_1.RequestKindEnum.PURCHASE_ORDER,
        expenseKind_enum_1.RequestKindEnum.STANDARD,
    ];
    const expenseKinds = isTravelEnabled ? [...commonExpenseKinds, expenseKind_enum_1.RequestKindEnum.MILEAGE, expenseKind_enum_1.RequestKindEnum.HOSPITALITY, expenseKind_enum_1.RequestKindEnum.PER_DIEM] : commonExpenseKinds;
    return {
        condition: workflowCondition_enum_1.WorkflowConditionEnum.EXPENSE_KIND,
        expenseKinds,
    };
};
exports.buildExpenseKindTriggerConditionForAllRequestTypes = buildExpenseKindTriggerConditionForAllRequestTypes;
